import React, { Component, createRef } from 'react';
import {
     withStyles,
     TextField,
     Button,
     Container,
     FormControl,
     InputLabel,
     Select,
     MenuItem,
     InputAdornment,
     IconButton,
     Chip
} from '@material-ui/core';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IEvent } from '../../core/models/edu.event';
import { TrixEditor } from 'react-trix';
import { ADD_EVENT, UPDATE_EVENT } from '../../core/handlers.actions/edu.events';
import moment from 'moment-timezone';
import AddIcon from '@material-ui/icons/Add';

moment.tz.setDefault('America/Los_Angeles');


const styles = (theme: any) => ({
     root: { '& .MuiTextField-root': { margin: theme.spacing(1), width: '100%' } },
     editBox: { borderTop: '2px solid #f50057', borderLeft: '2px solid #f50057', borderRight: '2px solid #f50057' },
     formControl: {
          margin: theme.spacing(1),
          minWidth: 120,
          width: '100%',
          marginBottom: 30
     },
     trixEditor: {
          marginBottom: 30,
          minWidth: 120,
          width: '100%'
     },
     chip: {
          margin: theme.spacing(0.5)
     },
     holderchip: {
          display: 'flex',
          justifyContent: 'center',
          '& > *': {
               margin: theme.spacing(0.5),
               listStyleType: 'none'
          }
     }
});

interface Props {
     classes: any;
     addEvent: (data: IEvent) => void;
     updateEvent: (data: IEvent) => void;
     reset: () => void;
     eventId: any;
     events: any;
}

interface State {
     name: string;
     eventName: string;
     category: string;
     type: any;
     _id: any;
     error: boolean;
     editing: boolean;
     status: string;
     createPage: boolean;
     timeZone: string;
     startDate: string;
     endDate: string;
     recordedDate: string;
     eventRegistrationLink: string;
     agenda: any;
     nursingHrs: any;
     slides: any;
     presenters: any;
     heroUrl: string;
     videoUrl: string;
     about: string;
     callToAction: string;
     agendaInput:string;
     nursingInput:string;
     slidesInput:string;
     presentersInput:string;
     eventPancanLink: string;
}

class EventForm extends Component<Props, State> {
     state: State = {
          name: '',
          eventName: '',
          category: '',
          type: '',
          error: false,
          _id: '',
          editing: false,
          status: '',
          createPage: false,
          timeZone: '',
          startDate: '',
          endDate: '',
          recordedDate: '',
          eventRegistrationLink: '',
          agenda: [],
          nursingHrs: [],
          slides: [],
          presenters: [],
          heroUrl: '',
          videoUrl: '',
          about: '',
          callToAction: '',
          agendaInput: '',
          nursingInput: '',
          slidesInput: '',
          presentersInput: '',
          eventPancanLink: ''
     };
     editor = createRef();

     constructor(props: Props) {
          super(props);
          this.validateForm = this.validateForm.bind(this);
          this.inputChangeHandler = this.inputChangeHandler.bind(this);
          this.submit = this.submit.bind(this);
          this.update = this.update.bind(this);
          this.cancel = this.cancel.bind(this);
          this.textFieldChange = this.textFieldChange.bind(this);
          this.setAlertUpdate = this.setAlertUpdate.bind(this);
          this.handleEditorReady = this.handleEditorReady.bind(this);
          this.inputHandlerRemoveItem = this.inputHandlerRemoveItem.bind(this);
          this.inputHandlerAddItem = this.inputHandlerAddItem.bind(this);
     }

     componentDidMount() {
          const { eventId } = this.props;
          if (!eventId) return console.log('This is a new alert');
          (document.getElementsByClassName('MuiContainer-root')[0]).scrollIntoView({
            behavior: 'smooth', // Optional for smooth scrolling
            block: 'start' // Ensures the top of the container is aligned with the top of the viewport
          });
          return this.setAlertUpdate();
     }

     public setAlertUpdate() {
          const { eventId, events } = this.props;
          const event = events.find((event: any) => event._id === eventId);
          const { name, eventName, _id, category, status, type, startDate, endDate, timeZone, createPage, details } = event;
          const { about, recordedDate, callToAction, eventRegistrationLink, agenda, nursingHrs, slides, presenters, assets, eventPancanLink } = details;
          const { heroImageUrl, videoUrl } = assets;

          this.setState({
               ...this.state,
               name,
               eventName,
               _id,
               category,
               status,
               type,
               editing: true,
               startDate,
               endDate,
               timeZone,
               createPage,
               about,
               recordedDate,
               callToAction,
               eventRegistrationLink,
               agenda,
               nursingHrs,
               slides,
               presenters,
               heroUrl: heroImageUrl,
               videoUrl,
               eventPancanLink
          });
     }

     public handleEditorReady(editor: any, name: string) {
          const { about, callToAction } = this.state;
          name === 'about' ? editor.insertHTML(about) : editor.insertHTML(callToAction);
     }

     public inputChangeHandler(e: any) {
          const { name, value } = e.target;
          return this.setState({ ...this.state, [name]: value });
     }

     public inputHandlerRemoveItem(list: string, item: string ) {
          const { agenda, nursingHrs, presenters, slides } = this.state;
          switch (list) {
               case 'agenda':
                    agenda.splice(agenda.indexOf(item), 1);
                    this.setState({ ...this.state, agenda });
                    break;
               case 'nursing':
                    nursingHrs.splice(nursingHrs.indexOf(item), 1);
                    this.setState({ ...this.state, nursingHrs });
                    break;
               case 'presenters':
                    presenters.splice(presenters.indexOf(item), 1);
                    this.setState({ ...this.state, presenters });
                    break;
               default:
                    slides.splice(slides.indexOf(item), 1);
                    this.setState({ ...this.state, slides });
          }
     }

     public inputHandlerAddItem(list:string) {
        const { agenda, nursingHrs, presenters, slides, agendaInput, nursingInput, presentersInput, slidesInput } = this.state;
        switch (list) {
            case 'agenda':
                 agenda.push(agendaInput);
                 this.setState({ ...this.state, agenda, agendaInput: '' });
                 break;
            case 'nursing':
                 nursingHrs.push(nursingInput);
                 this.setState({ ...this.state, nursingHrs, nursingInput: '' });
                 break;
            case 'presenters':
                 presenters.push(presentersInput);
                 this.setState({ ...this.state, presenters, presentersInput: '' });
                 break;
            default:
                 slides.push(slidesInput);
                 this.setState({ ...this.state, slides, slidesInput: '' });
       }
     }

     public validateForm() {
          const { name } = this.state;
          return name !== '' && name !== null;
     }

     public submit() {
          const { addEvent, reset } = this.props;
          const {
               name,
               eventName,
               category,
               status,
               type,
               startDate,
               endDate,
               timeZone,
               createPage,
               recordedDate,
               about,
               callToAction,
               eventRegistrationLink,
               agenda,
               nursingHrs,
               slides,
               presenters,
               heroUrl,
               videoUrl,
               eventPancanLink
          } = this.state;
          if (!this.validateForm()) return this.setState({ ...this.state, error: true });
          addEvent({
               name,
               eventName,
               category,
               status,
               type,
               startDate,
               endDate,
               timeZone,
               createPage,
               details: {
                    about,
                    recordedDate,
                    callToAction,
                    eventRegistrationLink,
                    eventPancanLink,
                    agenda,
                    presenters,
                    slides,
                    nursingHrs,
                    assets: {
                         heroImageUrl: heroUrl,
                         videoUrl
                    }
               }
          } as IEvent);
          this.setState({
               ...this.state,
               name: '',
               eventName: '',
               category: '',
               status: '',
               type: '',
               error: false,
               startDate: '',
               endDate: '',
               recordedDate: '',
               about: '',
               callToAction: '',
               eventRegistrationLink: '',
               agenda: [],
               nursingHrs: [],
               slides: [],
               presenters: [],
               heroUrl: '',
               videoUrl: '',
               timeZone: '',
               createPage: false,
               eventPancanLink: ''
          });
          reset();
     }

     public update() {
          const { updateEvent, reset } = this.props;
          const {
               _id,
               name,
               eventName,
               category,
               status,
               type,
               startDate,
               endDate,
               timeZone,
               createPage,
               about,
               recordedDate,
               callToAction,
               eventRegistrationLink,
               agenda,
               nursingHrs,
               slides,
               presenters,
               heroUrl,
               videoUrl,
               eventPancanLink
          } = this.state;
          if (!this.validateForm()) return this.setState({ ...this.state, error: true });
          updateEvent({
               _id,
               name,
               eventName,
               category,
               status,
               type,
               startDate,
               endDate,
               timeZone,
               createPage,              
               details: {
                    about,
                    recordedDate,
                    callToAction,
                    eventRegistrationLink,
                    eventPancanLink,
                    agenda,
                    presenters,
                    slides,
                    nursingHrs,
                    assets: {
                         heroImageUrl: heroUrl,
                         videoUrl
                    }
               }
          } as IEvent);
          this.setState({
               ...this.state,
               name: '',
               eventName: '',
               category: '',
               status: '',
               type: '',
               error: false,
               startDate: '',
               endDate: '',
               recordedDate: '',
               about: '',
               callToAction: '',
               eventRegistrationLink: '',
               agenda: [],
               nursingHrs: [],
               slides: [],
               presenters: [],
               heroUrl: '',
               videoUrl: '',
               timeZone: '',
               createPage: false,
               editing: false,
               eventPancanLink
          });
          reset();
     }

     public cancel() {
          const { reset } = this.props;
          this.setState({
               ...this.state,
               name: '',
               eventName: '',
               category: '',
               status: '',
               type: '',
               startDate: '',
               endDate: '',
               recordedDate: '',
               about: '',
               callToAction: '',
               eventRegistrationLink: '',
               agenda: [],
               nursingHrs: [],
               slides: [],
               presenters: [],
               heroUrl: '',
               videoUrl: '',
               timeZone: '',
               createPage: false,
               error: false,
               _id: '',
               editing: false,
               eventPancanLink: ''
          });
          reset();
     }

     public textFieldChange(html: any, text: any, name: string) {
          this.setState({ ...this.state, [name]: html });
     }

     public render() {
          const { classes } = this.props;
          const {
               name,
               eventName,
               category,
               status,
               type,
               error,
               editing,
               createPage,
               timeZone,
               startDate,
               endDate,
               recordedDate,
               eventRegistrationLink,
               agenda,
               nursingHrs,
               slides,
               presenters,
               heroUrl,
               videoUrl,
               about,
               callToAction,
               eventPancanLink,
               agendaInput,
               nursingInput,
               slidesInput,
               presentersInput
          } = this.state;
          
          return (
               <form className={classes.root} noValidate autoComplete="off">
                    {editing ? <h2>Update Event</h2> : <h2>Add Event</h2>}
                    <Container>
                         <TextField error={error} required name="name" label="Name" value={name || ''} onChange={this.inputChangeHandler} />
                         <TextField
                              error={error}
                              required
                              name="eventName"
                              label="Event Name"
                              value={eventName || ''}
                              onChange={this.inputChangeHandler}
                         />
                         <FormControl className={classes.formControl} required>
                              <InputLabel id="category-select">Select category</InputLabel>
                              <Select value={category || ''} name="category" onChange={this.inputChangeHandler}>
                                   <MenuItem value="education">Educational</MenuItem>
                                   <MenuItem value="webinar">Webinar</MenuItem>
                                   <MenuItem value="third-party">Third Party</MenuItem>
                                   <MenuItem value="gala">Gala</MenuItem>
                              </Select>
                         </FormControl>
                         <FormControl className={classes.formControl} required>
                              <InputLabel id="status-select">Status</InputLabel>
                              <Select value={status || ''} name="status" onChange={this.inputChangeHandler}>
                                   <MenuItem value="active">Active</MenuItem>
                                   <MenuItem value="inactive">Inactive</MenuItem>
                              </Select>
                         </FormControl>
                         <FormControl className={classes.formControl} required>
                              <InputLabel id="type-select">Select type</InputLabel>
                              <Select value={type || ''} name="type" onChange={this.inputChangeHandler}>
                                   <MenuItem value="upcoming">Upcoming</MenuItem>
                                   <MenuItem value="past-archived">Past or Archived</MenuItem>
                              </Select>
                         </FormControl>
                         <FormControl className={classes.formControl} required>
                              <InputLabel id="wp-select">Does it need to create a WP page</InputLabel>
                              <Select value={createPage || ''} name="createPage" onChange={this.inputChangeHandler}>
                                   <MenuItem value="true">Yes</MenuItem>
                                   <MenuItem value="false">No</MenuItem>
                              </Select>
                         </FormControl>
                         <FormControl className={classes.formControl} required>
                              <InputLabel id="state-select">TimeZone</InputLabel>
                              <Select value={timeZone || ''} name="timeZone" onChange={this.inputChangeHandler}>
                                   <MenuItem value="PDT">PDT</MenuItem>
                                   <MenuItem value="PST">PST</MenuItem>
                                   <MenuItem value="MST">MST</MenuItem>
                                   <MenuItem value="MDT">MDT</MenuItem>
                                   <MenuItem value="CST">CST</MenuItem>
                                   <MenuItem value="CDT">CDT</MenuItem>
                                   <MenuItem value="EST">EST</MenuItem>
                                   <MenuItem value="EDT">EDT</MenuItem>
                              </Select>
                         </FormControl>
                         {moment(startDate).isValid()?
                         <TextField
                         id="datetime-local-start"
                         label="Start Date"
                         type="datetime-local"
                         name="startDate"
                         defaultValue={moment(startDate).format('YYYY-MM-DDTHH:mm')}
                         InputLabelProps={{ shrink: true }}
                         onChange={this.inputChangeHandler}
                    />
                         :
                         <TextField
                         id="datetime-local-start"
                         label="Start Date"
                         type="datetime-local"
                         name="startDate"
                         defaultValue={moment().format('YYYY-MM-DDTHH:mm')}
                         InputLabelProps={{ shrink: true }}
                         onChange={this.inputChangeHandler}
                    />
                         }
                          {moment(endDate).isValid()?
                          <TextField
                          id="datetime-local-end"
                          label="End Date"
                          type="datetime-local"
                          name="endDate"
                          defaultValue={moment(endDate).format('YYYY-MM-DDTHH:mm')}
                          InputLabelProps={{ shrink: true }}
                          onChange={this.inputChangeHandler}
                     />
                          :
                          <TextField
                          id="datetime-local-end"
                          label="End Date"
                          type="datetime-local"
                          name="endDate"
                          defaultValue={moment().format('YYYY-MM-DDTHH:mm')}
                          InputLabelProps={{ shrink: true }}
                          onChange={this.inputChangeHandler}
                     />
                          }
                         {moment(recordedDate).isValid()?
                         <TextField
                         id="datetime-local-record"
                         label="Recorded Date"
                         type="datetime-local"
                         name="recordedDate"
                         defaultValue={moment(recordedDate).format('YYYY-MM-DDTHH:mm')}
                         InputLabelProps={{ shrink: true }}
                         onChange={this.inputChangeHandler}
                    />
                         :
                         <TextField
                         id="datetime-local-record"
                         label="Recorded Date"
                         type="datetime-local"
                         name="recordedDate"
                         defaultValue={moment().format('YYYY-MM-DDTHH:mm')}
                         InputLabelProps={{ shrink: true }}
                         onChange={this.inputChangeHandler}
                    />
                         }
                         
                         
                         <TrixEditor
                              autoFocus={false}
                              className={classes.trixEditor}
                              value={about || ''}
                              name="about"
                              placeholder="Overview..."
                              onChange={(html: any, text: any) => this.textFieldChange(html, text, 'about')}
                              onEditorReady={(e: any) => this.handleEditorReady(e, 'about')}
                         />

                         <TrixEditor
                              autoFocus={false}
                              className={classes.trixEditor}
                              name="callToAction"
                              value={callToAction || ''}
                              placeholder="Call to action..."
                              onChange={(html: any, text: any) => this.textFieldChange(html, text, 'callToAction')}
                              onEditorReady={(e: any) => this.handleEditorReady(e, 'callToAction')}
                         />                         
                         <TextField error={error}  name="eventRegistrationLink" label="Registration URL" value={eventRegistrationLink || ''} onChange={this.inputChangeHandler} />
                         <TextField
                              error={error}                              
                              name="eventPancanLink"
                              label="PanCAN URL"
                              value={eventPancanLink || ''}
                              onChange={this.inputChangeHandler}
                         />
                         <TextField
                              error={error}
                              multiline
                              rows={3}
                              name="agendaInput"
                              label="Agenda"
                              value={agendaInput || ''}
                              onChange={this.inputChangeHandler}
                              InputProps={{
                                   endAdornment: (
                                        <InputAdornment position="end">
                                             <IconButton edge="end" color="primary" onClick={(e:any) => this.inputHandlerAddItem('agenda')}>
                                             <AddIcon />
                                             </IconButton>
                                        </InputAdornment>
                                   )
                              }}
                         />
                         <div className={classes.holderchip} style={{ flexWrap: 'wrap' }}>
                              {agenda.length > 0
                                   ? agenda.map((item: string, index: number) => (
                                          <li key={`chip-agenda-${index}`}>
                                               <Chip label={item} onDelete={(e:any) => this.inputHandlerRemoveItem('agenda', item)} className={classes.chip} />
                                          </li>
                                     ))
                                   : null}
                         </div>

                         <TextField
                              multiline
                              rows={3}
                              error={error}
                              name="nursingInput"
                              label="Nursin Hrs"
                              value={nursingInput || ''}
                              onChange={this.inputChangeHandler}
                              InputProps={{
                                   endAdornment: (
                                        <InputAdornment position="end">
                                             <IconButton edge="end" color="primary" onClick={() => this.inputHandlerAddItem('nursing')}>
                                             <AddIcon />
                                             </IconButton>
                                        </InputAdornment>
                                   )
                              }}
                         />
                         <div className={classes.holderchip} style={{ flexWrap: 'wrap' }}>
                              {nursingHrs.length > 0
                                   ? nursingHrs.map((item: string, index: number) => (
                                          <li key={`chip-nursin-${index}`}>
                                               <Chip
                                                    label={item}
                                                    onDelete={(e:any) => this.inputHandlerRemoveItem('nursing', item)}
                                                    className={classes.chip}
                                               />
                                          </li>
                                     ))
                                   : null}
                         </div>

                         <TextField
                              error={error}
                              multiline
                              rows={3}
                              name="slidesInput"
                              label="Slide urls"
                              value={slidesInput || ''}
                              onChange={this.inputChangeHandler}
                              InputProps={{
                                   endAdornment: (
                                        <InputAdornment position="end">
                                             <IconButton edge="end" color="primary" onClick={() => this.inputHandlerAddItem('slides')}>
                                             <AddIcon />
                                             </IconButton>
                                        </InputAdornment>
                                   )
                              }}
                         />
                         <div className={classes.holderchip} style={{ flexWrap: 'wrap' }}>
                              {slides.length > 0
                                   ? slides.map((item: string, index: number) => (
                                          <li key={`chip-slides-${index}`}>
                                               <Chip label={item} onDelete={(e:any) => this.inputHandlerRemoveItem('slides', item)} className={classes.chip} />
                                          </li>
                                     ))
                                   : null}
                         </div>

                         <TextField
                              error={error}
                              multiline
                              rows={3}
                              name="presentersInput"
                              label="Presenters"
                              value={presentersInput || ''}
                              onChange={this.inputChangeHandler}
                              InputProps={{
                                   endAdornment: (
                                        <InputAdornment position="end">
                                             <IconButton edge="end" color="primary" onClick={() => this.inputHandlerAddItem('presenters')}>
                                             <AddIcon />
                                             </IconButton>
                                        </InputAdornment>
                                   )
                              }}
                         />
                         <div className={classes.holderchip} style={{ flexWrap: 'wrap' }}>
                              {presenters.length > 0
                                   ? presenters.map((item: string, index: number) => (
                                          <li key={`chip-presenters-${index}`}>
                                               <Chip
                                                    label={item}
                                                    onDelete={(e:any) => this.inputHandlerRemoveItem('presenters', item)}
                                                    className={classes.chip}
                                               />
                                          </li>
                                     ))
                                   : null}
                         </div>
                         <TextField error={error} name="heroUrl" label="Hero Url" value={heroUrl || ''} onChange={this.inputChangeHandler} />
                         <TextField error={error} name="videoUrl" label="Video Url" value={videoUrl || ''} onChange={this.inputChangeHandler} />

                         {editing ? (
                              <div>
                                   <Button variant="contained" color="primary" onClick={this.update}>
                                        Update Event
                                   </Button>
                                   &nbsp;&nbsp;
                                   <Button variant="contained" color="secondary" onClick={this.cancel}>
                                        Cancel
                                   </Button>
                              </div>
                         ) : (
                              <div>
                                   <Button variant="contained" color="primary" onClick={this.submit}>
                                        Add Event
                                   </Button>
                                   &nbsp;&nbsp;
                                   <Button variant="contained" color="secondary" onClick={this.cancel}>
                                        Cancel
                                   </Button>
                              </div>
                         )}
                    </Container>
               </form>
          );
     }
}

const mapProps = (app: any) => ({ events: app.rootReducer.events });
const actions = (dispatch: Dispatch) => ({
     addEvent: (data: IEvent) => dispatch({ type: ADD_EVENT, payload: data }),
     updateEvent: (data: IEvent) => dispatch({ type: UPDATE_EVENT, payload: data })
});
export default connect(mapProps, actions)(withStyles(styles)(EventForm));
